import { VehiclesFilters } from '../../vehicles/types/vehicles-filters';

/**
 * GPS tracking filters
 *
 * Currently identical to the vehicles filter set; kept as its own type so it can
 * diverge from vehicles filters independently in future.
 */
export class VehicleGpsTrackingFilters extends VehiclesFilters {}
